import { Auth0Provider, type AppState } from '@auth0/auth0-react'
import { type ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE } from '~/config/auth'

export function Auth0AppProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate()
  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience: AUTH0_AUDIENCE,
      }}
      onRedirectCallback={(state?: AppState) => {
        navigate(state?.returnTo ?? '/', { replace: true })
      }}
    >
      {children}
    </Auth0Provider>
  )
}
